import React from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { useWishlist } from "../context/WishlistContext";
import ProductCard from "../components/storefront/ProductCard";
import { Button } from "../components/ui/button";

export default function Favoris() {
  const { items } = useWishlist();
  return (
    <div className="mx-auto max-w-7xl px-4 py-10 sm:px-6 lg:px-8 lg:py-14" data-testid="favoris-page">
      <h1 className="font-serif text-4xl font-medium text-[#2C1A14] sm:text-5xl">Mes favoris</h1>
      <p className="mt-2 text-sm text-[#9B7E73]">Vos coups de cœur sont gardés sur cet appareil. Pièces uniques : ne tardez pas trop !</p>
      {items.length === 0 ? (
        <div className="py-20 text-center" data-testid="favoris-empty">
          <Heart className="mx-auto h-10 w-10 text-[#E8D5CE]" />
          <p className="mt-4 text-[#6E544A]">Aucun favori pour l'instant. Touchez le cœur d'une pièce pour la garder ici.</p>
          <Link to="/catalog"><Button className="mt-6 rounded-full bg-[#D76E4D] px-7 text-white hover:bg-[#C05A3A]">Découvrir le Dressing</Button></Link>
        </div>
      ) : (
        <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 sm:gap-6 lg:grid-cols-4">
          {items.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
        </div>
      )}
    </div>
  );
}
